import CharacterCountEllipsis from '../../helpers/CharacterCountEllipsis';
import {categoryTileEllipsesApplied}  from './CategoryTileEllipsisAppliedImport.js';

window.onload = function () {

	categoryTileEllipsesApplied(CharacterCountEllipsis);


	/** Brought this over from skye-js-utils.js - will have to get rid of this once
	 * I have a chance to rebuild the category-tile HTML 2-20-2020 e.f. 
	*/
};